import React, {createContext, useEffect, useReducer, useState} from 'react'
// import axios from '../../../../axios.js'


const reducer = (state, action) => {
    switch (action.type) {
        case 'RELOAD_STATE_QR': {
                return {
                    ...state,
                    QRScannerStatus: action.payload,
                }
        }
        default:
    }
};

const QRBarcodeScannerContext = createContext({
    QRScannerStatus: false,
    setStatusQRBarcodeScanner: ()=>{}
});

export const QRBarcodeScannerProvider = ({ settings, children }) => {
    const getInitialScannerStatus = () => {
        try {
            if (typeof window === 'undefined' || !window.localStorage) return false;
            const raw = window.localStorage.getItem('pixelcrm_qr_scanner_enabled');
            if (raw === null) return false;
            return raw === '1' || raw === 'true';
        } catch (e) {
            return false;
        }
    };

    const [state, dispatch] = useReducer(reducer, {
        QRScannerStatus: getInitialScannerStatus(),
    });

    const setStatusQRBarcodeScanner = async (status)=>{
        // console.log('что за жопа');
        try{
            console.log('Сменяем статус активности r сканера', status);
            dispatch({
                type: 'RELOAD_STATE_QR',
                payload: status,
            });
            try {
                if (typeof window !== 'undefined' && window.localStorage) {
                    window.localStorage.setItem('pixelcrm_qr_scanner_enabled', status ? '1' : '0');
                }
            } catch (e) {}
        }catch (e) {
            console.log('Ошибка при смене статуса вкл/выкл сканера', e);
        }
    }

    // const getALlStatusOrderServer = async () => {
    //     // console.log('Все работает, ну должно');
    //     try {
    //         const res = await axios.get('/api/reference/getAllStatusOrder');
    //         dispatch({
    //             type: 'LOAD_STATUS_ORDER',
    //             payload: res.data,
    //         });
    //
    //         return res.data;
    //     } catch (e) {
    //         console.error(e)
    //     }
    // };

    return (
        <QRBarcodeScannerContext.Provider
            value={{
                QRScannerStatus: state.QRScannerStatus,
                setStatusQRBarcodeScanner
            }}
            >
            {children}
        </QRBarcodeScannerContext.Provider>
    )
};

export default QRBarcodeScannerContext;
